import { IPreloadedState } from 'shared/types/redux';

export const selectNewBuildingInfo = (state: IPreloadedState) => state.houseInfo.geo.jk;
